<template>
  <div
    @focus="handleFocus"
    @focusout="handleFocusOut"
    tabindex="0"
    ref="frame"
    id="popup" v-if="isSidebarActiveLocal" :class="isSidebarActiveLocal ? 'active' : ''">
    <div tabindex="1"
         class="popup-cont">
      <h2 class="popup-heading">{{ this.data.add === true ? "ADD NEW" : "UPDATE" }} MODIFIER</h2>
      <div class="popup-item">
        <h4>Modifier Name</h4>
        <p>Only you will see this name. It will appear as a choice of selection when you want to add this modifier
          to a product.</p>
        <input type="text" class="pop-input" placeholder="Modifier Name" v-model="name" name="Modifier Name" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('Modifier Name')">{{ errors.first('Modifier Name') }}</span>
      </div>
      <div class="popup-item">
        <h4>Instructions to Customers</h4>
        <p>Describe how this modifier will effect your customers order.</p>
        <textarea class="pop-textarea"
                  placeholder="Example: Do you want to add sauce? or How do you like your meat preparation?"
                  v-model="instructions" name="Instructions" v-validate="'required'"></textarea>
        <span class="text-danger text-sm" v-show="errors.has('Instructions')">{{ errors.first('Instructions') }}</span>
      </div>
      <div class="popup-item">
        <h4>Modifier Options</h4>
        <div v-if="modifiers.length > 0" class="mod-inputs" v-for="(item,index) in modifiers" :key="index">
          <div class="mod-opt-input">
            <vs-input type="text"
                   class="pop-input mod-options"
                   placeholder="Modifier Option Name"
                   :value="item.name" @input="modifierNameChange(index, $event)"
                   :name="`option-name${index}`" v-validate="'required'" />
            <span class="text-danger text-sm"
                  v-show="errors.has(`option-name${index}`)">{{ errors.first(`option-name${index}`) ? errors.first(`option-name${index}`).replace(`option-name${index}`, `Option ${index}`) : '' }}</span>
          </div>
          <div class="mod-opt-input">
            <vs-input type="number"
                   class="pop-input mod-options"
                   placeholder="Modifier Price"
                   :value="item.price !== 0 ? item.price : ''" @input="modifierPriceChange(index, $event)"
                   name="option-price" />
            <p>Leave empty if this option is free</p>
          </div>
          <feather-icon class="ml-4 cursor-pointer" @click="deleteModifier(index)" icon="XIcon"  />
        </div>

        <div class="mod-button" @click="addModifier"><i class="fas fa-plus"></i> Add More</div>
      </div>
      <div class="popup-item">
        <h4>Requirement</h4>
        <p>Is customer required to select a choice from this list?</p>
        <vs-radio id="required" name="requirement" v-validate="'required'" v-model="requiredChoice" vs-value="yes"><label class="pop-radio-label" for="required">Required</label></vs-radio>
        <vs-radio id="not-required" name="requirement" v-validate="'required'" v-model="requiredChoice" vs-value="no"><label class="pop-radio-label" for="not-required">Not Required</label></vs-radio>
        <span class="text-danger text-sm"
              v-show="errors.has('requirement')">{{ errors.first('requirement') }}</span>
      </div>
      <div class="popup-item">
        <h4>Selection Limit</h4>
        <p>How many choices can the customer select?</p>

        <vs-radio id="one" v-model="howManyChoices" name="limitation" v-validate="'required'" vs-value="one"><label class="pop-radio-label" for="one">Only One</label></vs-radio>
        <vs-radio id="limitless" v-model="howManyChoices" name="limitation" v-validate="'required'" vs-value="nolimit"><label class="pop-radio-label" for="one">No Limit</label></vs-radio>
        <vs-radio id="min-max" v-model="howManyChoices" name="limitation" v-validate="'required'" vs-value="minmax"><label class="pop-radio-label" for="one">Set a Min-Max</label></vs-radio>
        <span class="text-danger text-sm"
              v-show="errors.has('limitation')">{{ errors.first('limitation') }}</span>
      </div>
      <div class="popup-item">
        <div v-if="howManyChoices === 'minmax'" class="minmax-item flex flex-wrap items-center">
          <div class="mod-opt-input">
          <input type="number"
                 class="pop-input mod-options"
                 placeholder="Min"
                 v-model="minChoice"
                 name="item-min"
                 v-validate="'required'" />
          </div>
          <div class="mod-opt-input">
          <input v-if="!unlimitedChoice"
                 type="number"
                 class="pop-input mod-options"
                 placeholder="Max"
                 v-model="maxChoice"
                 name="item-max"
                 v-validate="'required'" />
          </div>
          <div class="unlimited">
            <vs-checkbox v-model="unlimitedChoice" class="mt-5 vs-input--label">Unlimited max</vs-checkbox>
          </div>
          <span class="text-danger text-sm"
                v-show="errors.has('item-min')">{{ errors.first('item-min') }}</span>

          <span class="text-danger text-sm"
                v-show="errors.has('item-max')">{{ errors.first('item-max') }}</span>
        </div>
      </div>
      <div class="popup-item">
        <div class="tr-button blue-button popup-button" :class="isFormValid ? '' : 'inactive'" @click="submitData">{{ this.data.add === true ? "Add New" : "Update" }} Modifier</div>
        <div @click="isSidebarActiveLocal = false" class="tr-button popup-button">Cancel</div>
      </div>
    </div>
  </div>
</template>
<script>

import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data () {
    return {
      modifierId: null,
      name: '',
      instructions: '',
      restaurantId: null,
      minChoice: null,
      maxChoice: null,
      unlimitedChoice: false,
      requiredChoice: 'no',
      howManyChoices: 'one',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  mounted () {

  },
  watch: {
    isSidebarActive (val) {
      if (!val) {
        this.modifiers = []
        this.howManyChoices = ''
        this.requiredChoice = ''
        return
      }
      if (this.data.add === true) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { name, id, instructions, restaurant_id, min_choice, max_choice, unlimited_choice, required_choice, how_many_choices, items} = this.data

        this.modifierId = id
        this.name = name
        this.instructions = instructions
        this.restaurantId = restaurant_id
        this.modifiers = items
        this.minChoice = min_choice
        this.maxChoice = max_choice
        this.unlimitedChoice = unlimited_choice
        this.requiredChoice = (required_choice === 1) ? 'yes' : 'no'
        switch (how_many_choices) {
        case 2:
          this.howManyChoices = 'one'
          break
        case 3:
          this.howManyChoices = 'nolimit'
          break
        case 4:
          this.howManyChoices = 'minmax'
          break
        }
      }
      return true
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    modifiers: {
      get () {
        return this.$store.state.api.modifieritems
      },
      set (val) {
        this.$store.dispatch('api/setmodifieritems', val)
      }
    },
    isFormValid () {
      return !this.errors.any() && this.name && this.instructions
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {

    handleFocus () {
      // do something here
      this.isSidebarActiveLocal = false
    },
    handleFocusOut () {
      // do something here
    },
    initValues () {
      if (this.data.sectionId) return
      this.modifierId = null
      this.name = ''
      this.instructions = ''
      this.restaurantId = this.data.restaurantId
      this.addModifier()
    },
    modifierNameChange (index, e) {
      this.$store.dispatch('api/setmodifieritem', { type:'name', index, value: e})
    },
    modifierPriceChange (index, e) {
      if (e === '') {
        e = 0
      }
      this.$store.dispatch('api/setmodifieritem', { type:'price', index, value: e})
    },
    deleteModifier (index) {
      this.$store.dispatch('api/setmodifieritem', { type:'delete', index})
      this.$vs.notify({
        color: 'danger',
        title: 'Deleted modifier',
        text: 'The selected modifier was successfully deleted'
      })
    },
    addModifier () {
      const item = {
        id: null,
        name: '',
        price: 0.00,
        order: 0
      }
      this.$store.dispatch('api/setmodifieritem', { type:'add', value: item})
    },
    submitData () {

      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading()
          for (let i = 0; i < this.modifiers.length; i++) {
            this.$store.dispatch('api/setmodifieritem', { type:'order', index: i, value: i * 10})
          }

          const obj = {
            modifierId: this.modifierId,
            name: this.name,
            instructions: this.instructions,
            restaurantId: this.restaurantId,
            items: this.modifiers,
            minChoice: parseInt(this.minChoice),
            maxChoice: (!this.unlimitedChoice) ? parseInt(this.maxChoice) : null,
            unlimitedChoice: (this.unlimitedChoice) ? 1 : 0,
            requiredChoice: (this.requiredChoice === 'yes') ? 1 : 0,
            howManyChoices: parseInt(this.howManyChoices)
          }

          switch (this.howManyChoices) {
          case 'one':
            obj.howManyChoices = 2
            break
          case 'nolimit':
            obj.howManyChoices = 3
            break
          case 'minmax':
            obj.howManyChoices = 4
            break
          }


          this.$store.dispatch('api/addModifier', obj).then((response) => {
            this.$vs.notify({
              title: 'Success',
              text: response.data.message,
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
            this.$emit('closeSidebar')
            this.initValues()
            this.$vs.loading.close()
          }).catch(err => {
            console.error(err)
            this.$vs.notify({
              title: 'Error',
              text: err.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            this.$vs.loading.close()
          })

        }
      })
    },
    openConfirm (index) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        clickNotClose: true,
        title: 'Confirm',
        text: 'Are you sure to delete this item?',
        accept: this.deleteModifier(index)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .con-vs-dialog {
    z-index: 52011;
  }
  .size-item,.minmax-item {
    padding: 10px 0;
  }
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
  }
  .minmax-item .vs-con-input-label {
    width:25%;
  }
  .minmax-item .unlimited {
    width: 40%;
  }
  .size-item .vs-con-input-label {
    width:42%;
  }
</style>
